import { createSelector } from 'reselect';
import { getRegionNameRecursively } from '../../../../helpers/common';

const goalEntries = (state) => state.goalEntries.list;
const goalActions = (state) => state.goalActions.list;
const regions = (state) => state.regions.list;
const publisher = (state) => state?.user?.publisher || {};
const publisherRanks = (state) => state.publisherRanks;

export const getGoalEntries = createSelector(
    goalEntries,
    (goalEntries = []) => {
        return goalEntries;
    }
);

export const getGoalActions = createSelector(
    goalActions,
    (goalActions = []) => {
        const exclude = ['first_payment', 'replenish_payment'];

        return goalActions.filter(({ action }) => {
            return !exclude.includes(action.type);
        });
    }
);

export const getRegions = createSelector(
    regions,
    (regions = []) => {
        let object = {};

        regions.map((item) => {
            object[item.id] = getRegionNameRecursively(item);
        });

        return object;
    }
);

export const getCurrRank = createSelector(
    publisher,
    publisherRanks,
    (publisher, publisherRanks = []) => {
        return publisherRanks.find((item) => item.rank === publisher.rank);
    }
);
